/**
 * Menu controller.
 *
 * This class controls the site menu and search functions.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Menu
 */
class Dynamicmenu {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Dynamic menu DOM.
        this.$extraMenuLinks           = $( '.js-save-target-group' );
        this.$dynamicMenuWrapper       = $( '#js-dynamic-menu-wrapper' );
        this.$currentTargetGroup       = JSON.parse( localStorage.getItem( 'currentTargetGroup' ) );
        this.currentPostId             = themeData.currentPostId;
    }

    /**
     * All events of the menus
     * @return {void}
     */
    events() {

        if ( this.$extraMenuLinks.length ) {

            // Close cookie disclaimer + set local storage info
            this.$extraMenuLinks.on( 'click', e => {

                let $target = $( e.target );

                if ( ! $target.hasClass( 'js-save-target-group' ) ) {
                    $target = $target.closest( '.js-save-target-group' );
                }

                const postId = JSON.stringify( $target.attr( 'data-post-id' ) );

                localStorage.setItem( 'currentTargetGroup', postId );
            });
        }
    }

    /**
     * Add dynamic menu.
     */
    addDynamicMenu() {

        let parentId = false;

        // If there is this.$currentTargetGroup use it as a target group id.
        if ( this.$currentTargetGroup ) {
            parentId = this.$currentTargetGroup;
        }

        // Activate link in target group menu small.dust.
        $( '#js-target-group-small-link-' + parentId ).addClass( 'targetgroup-menu__item__link--active' );

        dp( 'ajaxAddDynamicMenu', {
            bypassMainQuery: false,
            args: {
                /*eslint-disable */
                ajax_params: {
                    lang: themeData.currentLang,
                    current_post_id: this.currentPostId,
                    parent_id: parentId,
                }
                /*eslint-enable */
            },
            success: ( data ) => {
                this.$dynamicMenuWrapper.html( data );

                const dynamicMenuParents = this.$dynamicMenuWrapper.find( '.js-main-menu-nav' );
                Theme.Menu.openCurrentMenu( dynamicMenuParents );
            },
            error: function( error ) {
                console.log( error );
            }
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();

        // If we need to add dynamic menu wrapper.
        if ( this.$dynamicMenuWrapper.length ) {
            this.addDynamicMenu();
        }
    }
}

// Export the class reference.
module.exports = Dynamicmenu;



// WEBPACK FOOTER //
// ./assets/scripts/dynamicmenu.js